import EZNotify from '../Alert/SimplerNotify';

export function TryAgain(props) {
  const disp = props?.errMsg ? props.errMsg : "Something went wrong."
  return <EZNotify styleName="danger" message={disp+" Press F5 (Command + R on a Mac) to try again."} 
          details={props.details}/>
}
